import { useEffect, useState } from 'react'
import { Grid, Button, Popover, MenuItem, Typography, useTheme, Box, Container, Stack } from '@mui/material'
import { cache } from '../utils/cache';
import { getLanguageOptions, getLogoImage, storeLanguageAsync } from '../utils/common';
import AlertComponent from '../components/Alert';
import LoadingComponent from '../components/Loading';
import PropTypes from "prop-types";
import ConfirmComponent from '../components/Confirm';
import { ArrowDownIcon, DetailsIcon } from '../components/IconComponent';
import { portal_config } from '../portal.config';
import { Languages } from '../Languages';
import i18n from '../translations/i18n';
import ContactUs from './informations/ContactUs';
import FAQs from './informations/FAQs';
import FormalitiesController from './informations/FormalitiesController';
import { useTranslation } from 'react-i18next';
import version_info from '../version.json';

function InitiatePage(props) {
    const { children, message, showProcessing, confirm, isHidden, showLanguage, showCRMLogo, useConfiguredLanguage, showMore, noFullScreenBackground } = props;
    const appConfig = cache.getAppConfig();
    let logoImage = getLogoImage();
    let preferredLanguageCode =  appConfig&& appConfig.features&& appConfig.features.contact&& appConfig.features.contact.contact&& appConfig.features.contact.contact.preferred_language_code;
    const { palette } = useTheme();
    const [currentLanguage, setLanguage] = useState(localStorage.getItem('language_id')? localStorage.getItem('language_id').toLowerCase():preferredLanguageCode.toLowerCase());
    const [defaultLanguage, setDefaultLanguage] = useState(null);
    const [anchorElLanguage, setAnchorElLanguage] = useState(null);
    const [anchorElMore, setAnchorElMore] = useState(null);
    const [target, setTarget] = useState({});
    const { t } = useTranslation();

    let [languages, setLanguages] = useState(getLanguageOptions(currentLanguage));

    const moreSettings = [
        {
            id: 'faqs',
            label: i18n.t('faq_title', { lng: currentLanguage }),
        },
        {
            id: 'contact_us',
            label: i18n.t('contact_us_title', { lng: currentLanguage }),
        },
        {
            id: 'formalities',
            label: i18n.t('formalities', { lng: currentLanguage }),
        },
        {
            id: 'version',
            label: t("version")+ " " + version_info.release_version
        },
    ]

    useEffect(() => {
        const translateLanguages = async (language) => {
          try {
            let languages=cache.getLanguages();
            let listLanguages = [];
    
            language&& languages&& languages.length>0 && languages.forEach(async item => {
                let exLanguage =Languages.filter(x => x.code.toLowerCase() == item.language_code.toLowerCase());
                let tranLabel = exLanguage[0].value.toLowerCase();
                let translationExists=i18n.exists(tranLabel, {lng: item.language_code.toLowerCase()});
                if(translationExists){
                    listLanguages.push({
                        value: exLanguage[0].code.toLowerCase(),
                        label: i18n.t(tranLabel, {lng: item.language_code.toLowerCase()}) ,
                    });
                }
                else{
                    listLanguages.push({
                        value: exLanguage[0].code.toLowerCase(),
                        label: exLanguage[0].value,
                    }); 
    
                }})
          
            setLanguages(listLanguages);
          } catch (error) {
            console.error('Error fetching data:', error);
          }
        };

        if (currentLanguage && languages && languages.length > 0) {
            let exLanguage = languages.filter(x => x.value.toLowerCase() === currentLanguage.toLowerCase());
            if (exLanguage && exLanguage.length > 0) {
                setDefaultLanguage(exLanguage[0]);
                storeLanguageAsync(exLanguage[0].value.toLowerCase());
                translateLanguages(exLanguage[0].value);
            }
            else {
                languages = portal_config.default_list_language;
                setDefaultLanguage('en')
                setLanguage('en')
                translateLanguages('en')
            }
        }
    }, []) 

    const handleOpenLanguages = (event) => {
        setAnchorElLanguage(event.currentTarget);
    };

     const handleOpenMore = (event) => {
        setAnchorElMore(event.currentTarget);
    };

    const onChangeLanguage = async (item) => {
        setAnchorElLanguage(null);
        let _language = languages.filter(x => x.value.toLowerCase() === item.value.toLowerCase());
        if (_language && _language.length > 0) {
            setLanguage(_language[0].value);
            await storeLanguageAsync(_language[0].value.toLowerCase());
            // let languageOptions=getLanguageOptions(_language[0].value);
            //find language from options
            let exLanguage = languages.filter(x => x.value.toLowerCase() === _language[0].value.toLowerCase());
            setDefaultLanguage(exLanguage[0]);
            // setLanguages(languageOptions);
            //await loadTranslations();
        }
    }

    // let backgroundImg = getImageBackground(appConfig.creatives, usage_type.landing_page_bg);
    let backgroundImg = null;
    let landingPageColor = palette.secondary.background;
    let optionsColour = null;

    if (palette.secondary.background.startsWith('#fff') || palette.secondary.background.startsWith('#000') ) 
    {
        optionsColour = palette.primary.main;
    }
    else if(palette.primary.main === palette.secondary.background)
    {
        optionsColour = '#ffffff'
    }
    else{
        optionsColour = palette.primary.main;
    }

    let cssBackgroundImage = {};
    if (backgroundImg && backgroundImg.url) {
        cssBackgroundImage = {
            backgroundImage: 'url(' + backgroundImg.url + ')',
            background: isHidden ? { xs: "none", md: '-webkit-image-set( url(' + backgroundImg.url + ') 1x, url(' + backgroundImg.url + ') 2x )' } : '-webkit-image-set( url(' + backgroundImg.url + ') 1x, url(' + backgroundImg.url + ') 2x )',
            minHeight: '90vh',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            alignItems: 'center'
        }
    } else {
        cssBackgroundImage = {
            backgroundColor: landingPageColor,
            alignItems: 'center',
            minHeight: noFullScreenBackground ? '25vh' : '90vh',
        }
    }

    const onClickItemProcess = async (target) => {
        setTarget({
            [target]: true,
        })
        setAnchorElMore(false);
    }

    return (
        <>
            <Grid item xs={12} container sx={cssBackgroundImage}>
                {(showLanguage || showMore) && (
                    <Grid container alignItems="center" justifyContent="space-between" sx={{ position: 'absolute', top: 16, px: 2}}>
                        <Grid item>
                            {showMore && (
                                <Button
                                    sx={{ justifyContent: 'flex-start' }}
                                    onClick={(e) => handleOpenMore(e)}
                                    size="large"
                                    id="header/moreOptions"
                                    startIcon={<DetailsIcon color={optionsColour}/>}
                                >
                                </Button>
                            )}
                        </Grid>

                        <Grid item>
                            {showLanguage && (
                                <Button
                                    onClick={(e) => handleOpenLanguages(e)}
                                    size="large"
                                    id="header/changeLanguage"
                                    endIcon={<ArrowDownIcon color={optionsColour}/>}
                                >
                                    <Typography variant='subtitle2' color={optionsColour}>
                                        {defaultLanguage ? defaultLanguage.label : ""}
                                    </Typography>
                                </Button>
                            )}
                        </Grid>
                    </Grid>
                )}

                {/* Popovers */}
                <Popover
                    id='list-languages'
                    anchorEl={anchorElLanguage}
                    open={Boolean(anchorElLanguage)}
                    onClose={() => setAnchorElLanguage(null)}
                    sx={{
                            top: 45,
                        }}                
                    >
                    {languages?.map((item, index) => (
                        <MenuItem key={index} onClick={() => onChangeLanguage(item)}>
                            <Typography variant='subtitle2'>{item.label}</Typography>
                        </MenuItem>
                    ))}
                </Popover>

                <Popover
                    id='list-more'
                    anchorEl={anchorElMore}
                    open={Boolean(anchorElMore)}
                    onClose={() => setAnchorElMore(null)}
                    sx={{
                        top: 45,
                    }} 
                    >
                    {moreSettings?.map((item, index) => (
                        <MenuItem key={index} onClick={() => onClickItemProcess(item.id)}>
                            <Typography variant='subtitle2'>{item.label}</Typography>
                        </MenuItem>
                    ))}
                </Popover>

                {logoImage && (
                    <Grid
                        sx={{ display: isHidden ? { xs: "none", md: "grid" } : "grid", mt: !noFullScreenBackground && -30}}
                        item
                        xs={12}
                        container
                        justifyContent={'center'}
                    >
                        <img src={logoImage} alt={'Logo Image'} height={200} />
                    </Grid>
                )}
            </Grid>

            <Grid item xs={12} container justifyContent={'center'} paddingY={isHidden ? { xs: 0, md: 3 } : 3} paddingX={3}>
                {children}
            </Grid>

            {/* Modals & Alerts */}
            {message?.show && (
                <AlertComponent
                    isOpen={message.show}
                    message={message.content}
                    title={message.title}
                    otherMessage={message.otherMessage ?? null}
                    onClose={message.callBackFn}
                />
            )}

            {showProcessing && <LoadingComponent showLoading={showProcessing} />}
            {confirm?.show && (
                <ConfirmComponent
                    isOpen={confirm.show}
                    message={confirm.message}
                    actionTitle={confirm.actionTitle}
                    closeTitle={confirm.closeTitle}
                    onClose={confirm.onClose}
                    onAction={confirm.onAction}
                />
            )}

            {target?.contact_us && <ContactUs open={target.contact_us} onClose={() => setTarget({})} />}
            {target?.faqs && <FAQs open={target.faqs} onClose={() => setTarget({})} />}
            {target && target.formalities && <FormalitiesController open={target.formalities} onClose={() => setTarget({})}/>}
        </>
    )
}

function getImageBackground(creatives, type) {
    let image = {};
    if (creatives && creatives.length > 0) {
        let landingPageImage = creatives.filter(x => x.usage_type && x.usage_type.toLowerCase() === type.toLowerCase());
        if (landingPageImage && landingPageImage.length > 0) {
            image = landingPageImage[0];
        }
    }
    return image;
}

InitiatePage.propTypes = {
    message: PropTypes.object,
    showProcessing: PropTypes.bool,
    confirm: PropTypes.object,
    showLanguage: PropTypes.bool,
    showCRMLogo: PropTypes.bool,
}

export default InitiatePage;